import {Directive} from '@angular/core';
import {Observable, fromEvent} from 'rxjs';
import * as $ from "jquery";
import {map} from "rxjs/operators";

@Directive({ selector: '[dkWatchScroll]' })
export class DkWatchScroll {
    private windowScroll: Observable<number>;

    constructor() {
        this.windowScroll = fromEvent(window, "scroll").pipe(map(() => window.scrollY));

        this.windowScroll.subscribe((newValue) => this.checkScroll(newValue));

        this.checkScroll(window.scrollY);
    }

    checkScroll(newValue) {
        if (newValue > 150) {
            $('body').addClass('small');
            $('.panel-header').addClass('small');
        } else {
            $('body').removeClass('small');
            $('.panel-header').removeClass('small');
        }
    }
}
